import _ from 'lodash';
import { connect } from 'react-redux';
import { createToolbarEvent } from 'jitsi/analytics/AnalyticsEvents';
import { sendAnalytics } from 'jitsi/analytics/functions';
import { leaveConference } from 'jitsi/base/conference/actions';
import { translate } from 'jitsi/base/i18n/functions';
import { HangupButton } from 'jitsi/toolbox/components/HangupButton';
import { openDialog } from 'jitsi/base/dialog/actions';
import { HangupDialog } from './HangupDialog';
class IISightHangupButton extends HangupButton {
    _hangup;
    accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
    label = 'toolbar.hangup';
    tooltip = 'toolbar.hangup';
    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._hangup = _.once(() => {
            sendAnalytics(createToolbarEvent('hangup'));
            this.props.dispatch(leaveConference());
        });
    }
    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        this.props.dispatch(openDialog('HangupDialog', HangupDialog, { onSubmit: this._hangup }));
    }
}
export default translate(connect()(IISightHangupButton));
